import { initializeApp } from 'firebase/app';

import { sentryLogger } from '@/adapters/logger/sentryLogger';

const state: { app: ReturnType<typeof initializeApp> | null } = { app: null };

const getFirebaseConfig = () => {
  const apiKey = process.env.EXPO_PUBLIC_FIREBASE_API_KEY;
  const authDomain = process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN;
  const projectId = process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID;
  const storageBucket = process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET;
  const messagingSenderId = process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID;
  const appId = process.env.EXPO_PUBLIC_FIREBASE_APP_ID;

  if (!apiKey || !authDomain || !projectId || !messagingSenderId || !appId) {
    const missingVars = [
      !apiKey && 'EXPO_PUBLIC_FIREBASE_API_KEY',
      !authDomain && 'EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN',
      !projectId && 'EXPO_PUBLIC_FIREBASE_PROJECT_ID',
      !messagingSenderId && 'EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID',
      !appId && 'EXPO_PUBLIC_FIREBASE_APP_ID',
    ].filter(Boolean);

    throw new Error(
      `Missing required Firebase configuration environment variables: ${missingVars.join(', ')}`,
    );
  }

  return {
    apiKey,
    authDomain,
    projectId,
    storageBucket: storageBucket || undefined,
    messagingSenderId,
    appId,
  };
};

const initializeFirebaseWeb = () => {
  if (state.app) {
    return state.app;
  }

  const config = getFirebaseConfig();

  state.app = initializeApp(config);
  sentryLogger.addBreadcrumb('Firebase initialized for web', { projectId: config.projectId });

  return state.app;
};

export { initializeFirebaseWeb };
